import { TurretActor } from "./TurretActor";
import * as Anuto from "../../../../engine/src";
import { AudioManager } from "../../../AudioManager";

export class SplatTurretActor extends TurretActor {

    constructor(scene: Phaser.Scene, position: {r: number, c: number}, turret: Anuto.Turret) {

        super(scene, Anuto.GameConstants.TURRET_SPLAT, position, turret, "texture_atlas_2", false);

        this.base.setFrame("torre_3_" + turret.level + "_01");
        this.base.setOrigin(.5, .75);
    }

    public upgrade(): void {

        super.upgrade();

        this.base.setFrame("torre_3_" + this.anutoTurret.level + "_01");
    }

    public shootGlue(): void {

        this.base.anims.play("torre_3_" + this.anutoTurret.level);

        let tarSpill = this.scene.add.sprite(0, 0, "texture_atlas_1");
        this.add(tarSpill);

        tarSpill.anims.play("tar_spill");

        AudioManager.playSound("tar_pump");

        tarSpill.on("animationcomplete", () => {
            tarSpill.destroy();
        }, this);
    }
}
